import { fireLinkTag } from './tagManager';

export function tagScrollyCatsLink(label) {
  fireLinkTag({
    event_name: `scrolly cat pills:${label}`,
    link_name: 'scrolly cat pills click',
    site_type: 'mobile',
  });
}
